import React, { useState, useEffect } from "react";
import "./styles.css";
import BgImage from "../assets/bg7.jpg";
import { useNavigate, useLocation } from "react-router-dom";
import Logo from "../assets/logo.jpg";
import Footer from "../components/Footer";
import {
  Grid,
  CircularProgress,
  styled,
  IconButton,
  InputAdornment,
  TextField,
  Box,
} from "@mui/material";
import useAuth from "../hooks/useAuth";
import { useMutation } from "react-query";
import apiClient from "../utils/clients/axiosWithoutToken";
import { handleToastMsg } from "../components/Components/Toast";
import { IsUserLoggedIn } from "../utils/login";
import { Visibility, VisibilityOff } from "@mui/icons-material";

const GlassBox = styled(Box)`
  backdrop-filter: blur(10px);
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

function Login() {
  const { setAuth, auth } = useAuth();
  const navigate = useNavigate();
  const [user, setUser] = useState("");
  const [pwd, setPwd] = useState("");
  const [errMsg, setErrMsg] = useState("");
  const location = useLocation();
  const from = location.state?.from?.pathname || "/";
  // report image links (/image/:kind/:id) return there after login
  const adminTarget = from.startsWith("/image/") ? from : "/admin";

  const isLoggedIn = IsUserLoggedIn();
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  useEffect(() => {
    if (isLoggedIn && auth?.roles?.length > 0) {
      if (auth.roles === "DATA ENTRY") {
        navigate(from, { replace: true });
      } else {
        navigate(adminTarget, { replace: true });
      }
    }
  }, [isLoggedIn, auth.roles, from, adminTarget, navigate]);

  const getLoginData = async (payload) => {
    const { data } = await apiClient.post(`/login`, payload);
    return data;
  };

  const { mutate: loginMutate, isLoading } = useMutation(getLoginData, {
    onSuccess: (res) => {
      const accessToken = res?.authToken;
      const roles = res?.user?.user_type;
      const userEmail = res?.user?.email;

      setAuth({ isAuthenticated: true, userEmail, roles, accessToken });
      setUser("");
      setPwd("");

      localStorage.setItem("authorization", accessToken);
      localStorage.setItem("role", JSON.stringify(roles));
      localStorage.setItem("user", userEmail);
      localStorage.setItem("isAuthenticated", true);

      if (roles === "DATA ENTRY") {
        navigate(from, { replace: true });
      } else {
        navigate(adminTarget, { replace: true });
      }
    },
    onError: (res) => {
      console.log(res.response.data.message);
      setErrMsg("Error Occurred!");
      handleToastMsg(
        res.response.data.message ? res.response.data.message : res.message,
        "error"
      );
    },
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    loginMutate({
      email: user,
      password: pwd,
    });
  };

  return (
    <Grid
      className="container"
      style={{
        backgroundImage: `url(${BgImage})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        minHeight: "100vh",
        overflow: "hidden",
        zIndex: 1,
      }}
      container
    >
      <GlassBox>
        <form onSubmit={handleSubmit}>
          <div style={{ textAlign: "center", marginBottom: "20px" }}>
            <img
              src={Logo}
              alt="Logo"
              height={80}
              width={80}
              style={{ borderRadius: "6px" }}
            />
          </div>
          <div className="form-field">
            <TextField
              label="Username"
              variant="outlined"
              fullWidth
              type="text"
              // placeholder="Username"
              required
              value={user}
              style={{ backgroundColor: "rgba(255, 255, 255, 0.2)" }}
              onChange={(e) => setUser(e.target.value)}
            />
          </div>
          <div className="form-field">
            <TextField
              type={showPassword ? "text" : "password"}
              label="Password"
              variant="outlined"
              required
              fullWidth
              value={pwd}
              onChange={(e) => setPwd(e.target.value)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      // edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              sx={{ backgroundColor: "rgba(255, 255, 255, 0.2)" }}
            />
            {/* <input
            type="password"
            placeholder="Password"
            required
            value={pwd}
            onChange={(e) => setPwd(e.target.value)}
          /> */}
          </div>
          <div className="form-field" style={{ justifyContent: "center" }}>
            <button className="btn" type="submit">
              {!isLoading ? (
                "Log in"
              ) : (
                <CircularProgress size={25} color="inherit" />
              )}
            </button>
          </div>
          {errMsg && (
            <p className="error-message" style={{ color: "#C41E3A" }}>
              {errMsg}
            </p>
          )}
        </form>
      </GlassBox>
      <Grid item container style={{ position: "absolute", bottom: 0 }}>
        <Footer />
      </Grid>
    </Grid>
  );
}

export default Login;
